<template>
  <b-form-group
    label="Kira Bedeli"
    label-for="amount"
  >
    <b-input-group>
      <b-form-input
        id="amount"
        v-model="dataItem.amount"
        placeholder="Kira Bedeli"
      />
      <b-input-group-append is-text>
        TL
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'TenantSelect',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estateTenants/dataItem']
    },
    dataList() {
      return this.$store.getters['tenants/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('tenants/getDataList')
    },
  },
}
</script>
